<template>
  <v-container fluid>
    <v-layout v-if="loading || waiting">
      <v-progress-linear indeterminate />
    </v-layout>

    <v-layout column v-else>
      <v-layout class="grey lighten-2 pa-2" align-content-space-between align-center row>
        <v-flex class="subtle mr-2" shrink>
          <v-icon>assignment_turned_in</v-icon>
        </v-flex>
        <v-flex>
          <h1 class="all-caps subtle">Coordinated Coverage Request</h1>
          <div v-if="role != 'employee'">
            <span v-if="request.must_fulfill" class="subtle">If the requested employee rejects this request, no shift will be created.</span>
            <span v-else class="subtle">If the requested employee rejects this request, the shift will become available to all eligible employees.</span>
          </div>
        </v-flex>
        <v-flex class="subtle text-xs-right">
          <div>
            <span class="font-weight-bold">Requested by:</span> {{ requestedBy.name }}
          </div>
          <div>
            <span class="font-weight-bold">Employee Requested:</span> {{ employeeRequested.display_name }}
          </div>
        </v-flex>
      </v-layout>

      <v-layout row my-5>
        <v-flex xs-5 mr-5>
          <ShiftHeader :shift="shift" />
        </v-flex>

        <v-flex xs-4 mx-5>
          <div v-if="shift.details" class="subtle">
            <p class="body-1"><span class="font-weight-bold text-uppercase">Shift Details: </span>{{ shift.details }}</p>
          </div>
          <div class="subtle">
            <p class="body-1 font-weight-bold">
              <BonusList :shift="shift" :role="role" />
            </p>
          </div>
          <v-layout row justify-left>
            <BonusView :shift="shift" type="travel" :role="role" />
            <BonusView :shift="shift" type="callIn" :role="role" />
            <BonusView :shift="shift" type="straight" :role="role" />
          </v-layout>
        </v-flex>

        <v-flex xs-3 ml-5>
          <CCReqActions
            :role="role"
            :pending="request.pending"
            :accepted="request.accepted"
            :cancelled="request.cancelled"
            :mustFulfill="request.must_fulfill"
            :rejected="request.rejected"
            :shiftId="request.resulting_shift_id"
            @accept="handleAccept"
            @reject="handleReject"
            @cancel="handleCancel"
          />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ShiftHeader from '@/components/calendar/shift-header.vue'
import CCReqActions from '@/components/coordinated-coverage-requests/coordinated-coverage-request-actions.vue'

export default {
  props: [
    'request',
    'loading',
    'shift',
    'role',
    'requestedBy',
    'employeeRequested',
  ],
  components: {
    ShiftHeader,
    CCReqActions
  },
  data () {
    return {
      waiting: false,
    }
  },
  methods: {
    handleAccept: function() {
      this.$emit('accept')
    },
    handleReject: function() {
      this.$emit('reject')
    },
    handleCancel: function() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.pending-approval {

}
</style>
